@if(globals.showsplash) {
    <app-full-loader />
}
<router-outlet />
